import { render, staticRenderFns } from "./nav_item.vue.js?vue&type=template&id=5387e7b2&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./nav_item.vue?vue&type=template&id=5387e7b2&vue3"
import script from "./nav_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./nav_item.vue?vue&type=script&lang=js&vue3"
export * from "./nav_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./nav_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports